
namespace RioERP.Products {

    @Serenity.Decorators.registerClass()
    export class ProductsDialog extends Serenity.EntityDialog<ProductsRow, any> {
        protected getFormKey() { return ProductsForm.formKey; }
        protected getIdProperty() { return ProductsRow.idProperty; }
        protected getLocalTextPrefix() { return ProductsRow.localTextPrefix; }
        protected getNameProperty() { return ProductsRow.nameProperty; }
       /* protected getService() { return ProductsService.baseUrl; }*/
        protected getDeletePermission() { return ProductsRow.deletePermission; }
        protected getInsertPermission() { return ProductsRow.insertPermission; }
        protected getUpdatePermission() { return ProductsRow.updatePermission; }

        protected form = new ProductsForm(this.idPrefix);

        private productSpecificationsGrid1: ProductSpecificationsGrid1;
        private productPendrivesGrid1: ProductPendrivesGrid1;
        private productBookGrid1: ProductBooksGrid1;
        private productBillingItemsGrid1: ProductBillingItemsGrid1;
        private productBillingItemSpecificationGrid: ProductBillingItemSpecificationsGrid;

        
        private loadedState: string;

        constructor() {
            super();

            this.productSpecificationsGrid1 = new ProductSpecificationsGrid1(this.byId("ProductSpecificationsGrid"));
            this.productSpecificationsGrid1.element.flexHeightOnly(1);

            this.productPendrivesGrid1 = new ProductPendrivesGrid1(this.byId("ProductPendrivesGrid1"));
            this.productPendrivesGrid1.element.flexHeightOnly(1);

            this.productBookGrid1 = new ProductBooksGrid1(this.byId("ProductBooksGrid1"));
            this.productBookGrid1.element.flexHeightOnly(1);


            this.productBillingItemsGrid1 = new ProductBillingItemsGrid1(this.byId("ProductBillingItemsGrid1"));
            this.productBillingItemsGrid1.element.flexHeightOnly(1);

            this.productBillingItemSpecificationGrid = new ProductBillingItemSpecificationsGrid(this.byId("ProductBillingItemSpecificationsGrid"));
            this.productBillingItemSpecificationGrid.element.flexHeightOnly(1);

         


            DialogUtils.pendingChangesConfirmation(this.element, () => this.getSaveState() != this.loadedState);
            this.tabs.on('tabsactivate', (e, i) => { this.arrange() });

            this.form.EValidityType.changeSelect2(e => {
                var vValidityType = this.form.EValidityType.value;

                if (Q.isEmptyOrNull(vValidityType)) {
                    // this.setProductDetails({});
                    this.form.ValidTill.getGridField().toggle(false);
                    this.form.EValidity.getGridField().toggle(false);
                   
                }
                else {

                    if (vValidityType == '1' || vValidityType == '2') {

                        if (vValidityType == '2') {
                            this.form.ValidTill.getGridField().toggle(false);
                            this.form.EValidity.getGridField().toggle(true);
                            }
                        else {
                            this.form.ValidTill.getGridField().toggle(true);
                            this.form.EValidity.getGridField().toggle(false);
                            }
                    }

                }

            });
        }

        getSaveState() {
            try {
                return $.toJSON(this.getSaveEntity());
            }
            catch (e) {
                return null;
            }
        }

        loadResponse(data) {
            super.loadResponse(data);
            Serenity.TabsExtensions.setDisabled(this.tabs, 'ProductSpecifications', this.isNewOrDeleted());

            Serenity.TabsExtensions.setDisabled(this.tabs, 'ProductPendrives', this.isNewOrDeleted());

            Serenity.TabsExtensions.setDisabled(this.tabs, 'ProductBooks', this.isNewOrDeleted());

            Serenity.TabsExtensions.setDisabled(this.tabs, 'ProductBillingItems', this.isNewOrDeleted());

            Serenity.TabsExtensions.setDisabled(this.tabs, 'ProductBillingItemSpecifications', this.isNewOrDeleted());

            
            this.loadedState = this.getSaveState();
        }

        loadEntity(entity: ProductsRow) {
            super.loadEntity(entity);

            if (this.isNew()) {
                this.form.ValidTill.getGridField().toggle(false);
                this.form.EValidity.getGridField().toggle(false);
            }
            else {

                var vValidityType = this.form.EValidityType.value;

                if (Q.isEmptyOrNull(vValidityType)) {
                    // this.setProductDetails({});
                    this.form.ValidTill.getGridField().toggle(false);
                    this.form.EValidity.getGridField().toggle(false);

                }
                else {

                    if (vValidityType == '1' || vValidityType == '2') {

                        if (vValidityType == '2') {
                            this.form.ValidTill.getGridField().toggle(false);
                            this.form.EValidity.getGridField().toggle(true);
                        }
                        else {
                            this.form.ValidTill.getGridField().toggle(true);
                            this.form.EValidity.getGridField().toggle(false);
                        }
                    }

                }
            }

            Serenity.TabsExtensions.setDisabled(this.tabs, 'ProductSpecifications', this.isNewOrDeleted());

            Serenity.TabsExtensions.setDisabled(this.tabs, 'ProductPendrives', this.isNewOrDeleted());

            Serenity.TabsExtensions.setDisabled(this.tabs, 'ProductBooks', this.isNewOrDeleted());

            Serenity.TabsExtensions.setDisabled(this.tabs, 'ProductBillingItems', this.isNewOrDeleted());

            Serenity.TabsExtensions.setDisabled(this.tabs, 'ProductBillingItemSpecifications', this.isNewOrDeleted());

            this.productSpecificationsGrid1.ProductId = entity.Id;
            this.productPendrivesGrid1.ProductId = entity.Id;
            this.productBookGrid1.ProductId = entity.Id;
            this.productBillingItemsGrid1.ProductId = entity.Id;
            this.productBillingItemSpecificationGrid.ProductId = this.entityId;
        }


        protected afterLoadEntity() {
            super.afterLoadEntity();
            this.productSpecificationsGrid1.ProductId = this.entityId;
            this.productPendrivesGrid1.ProductId = this.entityId;
            this.productBookGrid1.ProductId = this.entityId;
            this.productBillingItemsGrid1.ProductId = this.entityId;
            this.productBillingItemSpecificationGrid.ProductId = this.entityId;

            //Passing discount to OrderProduct Editor
            //   this.form.OrderProducts.discount = this.form.DiscountPer.value;
        }

        protected validateBeforeSave() {
            var isValidate = super.validateForm();
            if (isValidate) {
                isValidate = super.validateBeforeSave();
            }
            //if (this.form.OrderProducts.rowCount() == 0) {
            //    Q.alert("At least one Product is mandatory for Order.");
            //    return false;
            //}
            return isValidate;
        }
    }
}